import { resolvePath } from "@utils/resolvePath";
import {
    CallbackContainer,
    CallBackHeader,
    CallBackText,
} from "./styles";
import { Flex } from "@acko-tech/building-blocks.ui.common";

const AckoDriveCallbackModal = (props: any) => {
    const { actions } = props

    return (
        <CallbackContainer>
            <Flex flexDirection={"column"} alignItems="flex-start">
                <img src={resolvePath("/images/Call.svg")} alt={"get-call-back"} height={"80px"} />
                <CallBackHeader>We'll call you soon!</CallBackHeader>
                <CallBackText>We’ve received your callback request and will connect with your shortly. In the meantime, explore our plans and features.</CallBackText>
            </Flex>

        </CallbackContainer>
    );
};

export default AckoDriveCallbackModal;
